<app-loader *ngIf="isLoading"></app-loader>
<div *ngIf="facilitiesDataFG && !isLoading" class="component-container facilities-container bk-page-break">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div
      class="page-heading text-center text-uppercase"
      *ngIf="currentFlowType === installationFlowType.NewInstallation && formIndex === 0">
      {{ 'facilities-data.' + currentFormType.key | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
    <div
      class="page-heading text-center text-uppercase"
      *ngIf="currentFlowType === installationFlowType.UpdateInstallation && formIndex === 0">
      {{ 'facilities-data.update-installation.' + currentFormType.key | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>
  <ng-container
    *ngIf="
      (currentFlowType === installationFlowType.NewInstallation || currentFlowType === installationFlowType.UpdateInstallation) &&
      currentFormType.index === 1 &&
      environmentService?.showTechnicalDataFeverPlantSection
    ">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <div class="margin-header-align text-uppercase page-title">
        {{ 'facilities-data.heating-data-title' | translate }}
      </div>
    </div>

    <app-review-section
      [title]="'facilities-data.construction-title' | translate"
      [tooltip]="'tooltips.facilities-data.construction' | translate"
      [sectionId]="sectionIdentifier.TechnicalData_CombustionPlantInfo"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-technical-data-heating
          [furnaceData]="this.facilitiesDataFG.furnaceData"
          [firingSystemData]="this.facilitiesDataFG.firingSystemData"
          [isReadOnly]="isReadOnly"
          [currentFlowType]="currentFlowType"
          [applicationId]="applicationId"
          [isDetailsView]="isDetailsView"></app-technical-data-heating>
      </div>
    </app-review-section>
  </ng-container>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div *ngIf="installationChangeType" class="margin-header-align text-uppercase page-title">
      {{ 'facilities-data.title' | translate }} {{ getTechDataFormIndex() }} -
      {{
        'lookup.' + (changeGas === '1' ? 'sk_inst_change_type_gas' : 'sk_inst_change_type') + '.options.' + installationChangeType + '.name'
          | translate
      }}
    </div>
    <div *ngIf="!installationChangeType" class="margin-header-align text-uppercase page-title">
      {{ 'facilities-data.title' | translate }} {{ getTechDataFormIndex() }}
    </div>
    <div *ngIf="!isReadOnly && allowDelete" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 right-aligned">
      <div (click)="deleteTechnicalData()" class="pi pi-trash pointer-cursor"></div>
    </div>
  </div>

  <div *ngIf="currentFlowType === installationFlowType.UpdateInstallation">
    <app-review-section
      #techDataMediaSection
      [title]="'personal-data.media' | translate"
      [tooltip]="'tooltips.facilities-data.media' | translate"
      [showTooltip]="infoBubblesData?.showMediaHeaderInfo"
      [sectionId]="techDataMediaSectionIdentifier"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin disabled-section">
        <div class="ui-g-3 center_aligned">
          <span class="icon icon-electricity pointer-cursor" id="power" [ngClass]="changePower === '1' ? 'active-icon' : ''"></span>
          <div class="icon-label" [ngClass]="changePower === '1' ? 'active-icon-label' : ''">
            {{ 'overview.details-data.data-rows.power' | translate }}
          </div>
          <div class="meter-type-dropdown" *ngIf="isReadOnly">
            <p-dropdown
              [options]="installationChangeTypes"
              [ngModel]="powerInstallationChangeType"
              [ngModelOptions]="{ standalone: true }"
              id="facility-power-dropdown"
              placeholder="-Select-"
              [disabled]="true">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + installationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + installationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-3 center_aligned">
          <span class="icon icon-gas pointer-cursor" id="gas" [ngClass]="changeGas === '1' ? 'active-icon' : ''"></span>
          <div class="icon-label" [ngClass]="changeGas === '1' ? 'active-icon-label' : ''">
            {{ 'overview.details-data.data-rows.gas' | translate }}
          </div>
          <div class="meter-type-dropdown" *ngIf="isReadOnly">
            <p-dropdown
              [options]="gasInstallationChangeTypes"
              [ngModel]="gasInstallationChangeType"
              [ngModelOptions]="{ standalone: true }"
              id="facility-gas-dropdown"
              placeholder="-Select-"
              [disabled]="true">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + gasInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-3 center_aligned">
          <span class="icon icon-water pointer-cursor" id="water" [ngClass]="changeWater === '1' ? 'active-icon' : ''"></span>
          <div class="icon-label" [ngClass]="changeWater === '1' ? 'active-icon-label' : ''">
            {{ 'overview.details-data.data-rows.water' | translate }}
          </div>
          <div class="meter-type-dropdown" *ngIf="isReadOnly">
            <p-dropdown
              [options]="waterInstallationChangeTypes"
              [ngModel]="waterInstallationChangeType"
              [ngModelOptions]="{ standalone: true }"
              id="facility-water-dropdown"
              placeholder="-Select-"
              [disabled]="true">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + waterInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-3 center_aligned">
          <span class="icon icon-geothermal pointer-cursor" id="heating" [ngClass]="changeHeat === '1' ? 'active-icon' : ''"></span>
          <div class="icon-label" [ngClass]="changeHeat === '1' ? 'active-icon-label' : ''">
            {{ 'overview.details-data.data-rows.heating' | translate }}
          </div>
          <div class="meter-type-dropdown" *ngIf="isReadOnly">
            <p-dropdown
              [options]="heatingInstallationChangeTypes"
              [ngModel]="heatingInstallationChangeType"
              [ngModelOptions]="{ standalone: true }"
              id="facility-heating-dropdown"
              placeholder="-Select-"
              [disabled]="true">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + heatingInstallationChangeTypesKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>
    </app-review-section>
  </div>

  <ng-container>
    <ng-container *ngIf="environmentService.copyExistingTechnicalDataConfiguration">
      <app-new-facility
        *ngIf="this.facilitiesDataFG.newFacilityData"
        [isReadOnly]="isReadOnly"
        [currentFormType]="currentFormType"
        [newFacilityData]="this.facilitiesDataFG.newFacilityData"></app-new-facility>

      <div
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
        *ngIf="showFormElement && showNewMeterSection">
        <app-meter-data
          [formType]="currentFormType"
          [isReadOnly]="isReadOnly"
          [meterData]="this.facilitiesDataFG.meterData"
          [chimneySweepData]="this.facilitiesDataFG.chimneySweepData"
          [selectedMeasuringPointOperator]="selectedMeasuringPointOperator"
          [selectedPeakFlowRateValue]="peakFlowRateValue"></app-meter-data>
      </div>
    </ng-container>

    <app-review-section
      *ngIf="facilitySectionIdentifier"
      #baseDataSection
      [title]="'facilities-data.base-data-title' | translate"
      [tooltip]="'tooltips.facilities-data.base-data-header-info' | translate"
      [sectionId]="facilitySectionIdentifier"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
      <div *ngIf="showFormElement && currentFormType.index <= 3">
        <ng-container *ngFor="let value of baseDataCount; let index = index">
          <app-base-data
            [baseDataLength]="baseDataCount.length"
            [isReadOnly]="!baseDataSection.isDataEditable"
            [currentFormType]="currentFormType"
            [baseData]="this.facilitiesDataFG.baseData[index]"
            [currentIndex]="index"
            (deleteComponent)="removeBaseData(index)"></app-base-data>
        </ng-container>

        <div
          [class.new-facility-button]="baseDataCount.length > 0"
          class="ui-g-12 margin-align add-button-row form-font-size"
          *ngIf="baseDataSection.isDataEditable && currentFormType.index < 3 && showData">
          <i
            (click)="addBaseData()"
            class="pi pi-plus plus-icon new-facility-plus-icon"
            id="base-data-add-facility"
            tabindex="0"
            appEnterClick></i>
          <label class="ui-g-5 field-label" for="base-data-add-facility">
            {{ 'facilities-data.form-fields.facility-button' | translate }}
          </label>
        </div>
      </div>

      <ng-container *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
        <app-new-facility
          *ngIf="this.facilitiesDataFG.newFacilityData"
          [isReadOnly]="!baseDataSection.isDataEditable"
          [currentFormType]="currentFormType"
          [newFacilityData]="this.facilitiesDataFG.newFacilityData"></app-new-facility>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
          *ngIf="showFormElement && showNewMeterSection">
          <app-meter-data
            [formType]="currentFormType"
            [isReadOnly]="!baseDataSection.isDataEditable"
            [meterData]="this.facilitiesDataFG.meterData"
            [chimneySweepData]="this.facilitiesDataFG.chimneySweepData"
            [selectedMeasuringPointOperator]="selectedMeasuringPointOperator"
            [selectedPeakFlowRateValue]="peakFlowRateValue"
            [applicationId]="applicationId"
            [isDetailsView]="isDetailsView"></app-meter-data>
        </div>
      </ng-container>
    </app-review-section>
  </ng-container>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
    *ngIf="currentFlowType === installationFlowType.UpdateInstallation && environmentService.showOldMeterSection">
    <app-old-meter-data
      [currentFormType]="currentFormType"
      [currentInstallationType]="installationChangeType"
      [oldMeterData]="this.facilitiesDataFG.oldMeterData"
      [isReadOnly]="isReadOnly"
      [isDetailsView]="isDetailsView"></app-old-meter-data>
  </div>

  <div class="ui-g-12 clone-data-container" *ngIf="environmentService.copyExistingTechnicalDataConfiguration">
    <div class="ui-g form-rows">
      <div
        class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows margin-align add-button-row form-font-size"
        *ngIf="!isReadOnly && currentFormType.index < 3 && showData">
        <i
          (click)="cloneTechnicalData(false)"
          class="pi pi-plus plus-icon new-facility-plus-icon"
          [class.disabled]="true"
          id="clone-empty-technical-data-button"
          tabindex="0"
          appEnterClick></i>
        <label class="ui-g-5 field-label" for="clone-empty-technical-data-button">
          {{ 'facilities-data.form-fields.clone-empty-technical-data-button' | translate }}
        </label>
      </div>
      <div
        class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows margin-align add-button-row form-font-size"
        *ngIf="!isReadOnly && currentFormType.index < 3 && showData">
        <i
          (click)="cloneTechnicalData(true)"
          class="pi pi-plus plus-icon new-facility-plus-icon"
          [class.disabled]="true"
          id="clone-technical-data-button"
          tabindex="0"
          appEnterClick></i>
        <label class="ui-g-5 field-label" for="clone-technical-data-button">
          {{ 'facilities-data.form-fields.clone-technical-data-button' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
